/* eslint-disable @typescript-eslint/no-explicit-any */
import urls from 'routes/urls';
import { fetchData } from 'utils/customUseQuery';
import endPoints from 'utils/platformEndPoints/ossix';

/**
 * Pages that only make sense with a bank account behind them. While the
 * account is still being opened they stay visible in the navigation but are
 * locked, and opening one by URL shows the "account being opened" page.
 */
export const ACCOUNT_LOCKED_PATHS = [
  urls.accounts,
  urls.transactions,
  urls.payBills,
  urls.beneficiary,
  urls.localTransfer,
  urls.transferBetweenOwnAccount,
  urls.internationalTransfer,
  urls.payTax,
  urls.withdraw,
  urls.operators,
  urls.cashWithdraw,
  urls.quickPay,
  urls.microloan,
  urls.cards,
];

export const isAccountLockedPath = (pathname: string) =>
  ACCOUNT_LOCKED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );

/**
 * True only for an explicit "no linked account" answer: `[]`, or the
 * platform's `[{ LinkedAccountFound: 'NO' }]`. Anything else (still
 * loading, a network failure, an error body) is NOT pending, so a glitch
 * can never lock a real customer out of their account.
 */
export const isAccountPending = (accounts: unknown) =>
  Array.isArray(accounts) &&
  (accounts.length === 0 ||
    (accounts.length === 1 &&
      (accounts[0] as any)?.LinkedAccountFound === 'NO'));

/**
 * Reads the GetLinkedAccountList query (same cache key as the dashboard, so
 * no extra network call). Uses the RAW data on purpose: the shared
 * `userAccountNumbers()` turns "no data" into `[]`, which would make a
 * failed request look like "no account".
 */
export default (enabled = true) => {
  const { data, isLoading, isSuccess } = fetchData({
    url: endPoints.GetLinkedAccountList,
    enabled,
  });
  return {
    isLoading,
    isPending: isSuccess && isAccountPending(data),
  };
};
